export function formatImageUrl(url) {
    const replaceUrl = url.replace("http", "https");
    return replaceUrl.replace("emea.guccigroup.dom", "tech.gucci");
}

export function naturalSortKey(name) {
    // Extract filename stem (without extension)
    const stem = name.includes('.')
        ? name.substring(0, name.lastIndexOf('.'))
        : name;

    // Split by digit sequences
    const parts = stem.split(/(\d+)/);
    const key = [];

    for (const part of parts) {
        if (!part) continue;

        if (/^\d+$/.test(part)) {
            // Numeric chunk
            key.push([0, parseInt(part)]);
        } else {
            // Text chunk: remove separators so "2 a" and "2-a" are compared as "2a"
            const normalized = part.replace(/[\s_\-]+/g, '').toLowerCase();
            key.push([1, normalized]);
        }
    }

    // Ensure plain numeric names (e.g., 53.jpg) come before suffixed ones (e.g., 53A.jpg)
    key.push([1, '']);
    // Use full lowercase filename as deterministic tie-breaker
    key.push([2, name.toLowerCase()]);

    return key;
}

// Comparator function for sorting
export function compareKeys(keyA, keyB) {
    for (let i = 0; i < Math.max(keyA.length, keyB.length); i++) {
        const a = keyA[i];
        const b = keyB[i];

        if (!a) return -1;
        if (!b) return 1;

        if (a[0] !== b[0]) return a[0] - b[0];
        if (a[1] < b[1]) return -1;
        if (a[1] > b[1]) return 1;
    }
    return 0;
}

export function getReadableFileSizeString(bytes, si = false, dp = 1) {
    let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    if (bytes === 0) return 'n/a';
    let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    if (i === 0) return bytes + ' ' + sizes[i];
    return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
}
 export function formatDate(date) {
     return new Intl.DateTimeFormat("it-IT", {
         day: "2-digit",
         month: "2-digit",
         year: "numeric",
         hour: "2-digit",
         minute: "2-digit",
     }).format(new Date(date));
 }
